export function isValueInEnum<T extends object>(enumType: T, value: any): boolean {
    return Object.values(enumType).includes(value);
}
